import type { CountryCode } from '@/graphql/api'

const regionalIndicatorBase = 0x1f1e6
const latinUppercaseA = 65

/**
 * @see https://gomakethings.com/articles/getting-emoji-from-country-codes-with-vanilla-javascript/
 */
export const countryFlagEmoji = (isoCode: CountryCode): string => {
    const codePoints = [...isoCode].map(
        (char) => regionalIndicatorBase + char.charCodeAt(0) - latinUppercaseA
    )

    return String.fromCodePoint(...codePoints)
}
